import React from 'react';

export const MessengerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.9 1.15 5.46 3.12 7.33V22l2.86-1.57c1.27.35 2.61.54 4.02.54 5.64 0 10-4.13 10-9.7C22 6.13 17.64 2 12 2zm1.29 12.19l-2.3-2.45-4.48 2.45 4.92-5.23 2.35 2.45 4.43-2.45-4.92 5.23z"/>
  </svg>
);

export const TwitterXIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

// Renders a single AI provider pill button (used in preview and live widget)
export const AiProviderButton = ({ provider, style: btnStyle = 'pill', size = 'medium' }) => {
  const sizeMap = {
    small:  { padding: '5px 12px',  fontSize: '12px', gap: '5px',  iconSize: 14 },
    medium: { padding: '7px 16px',  fontSize: '13px', gap: '6px',  iconSize: 16 },
    large:  { padding: '10px 22px', fontSize: '15px', gap: '8px',  iconSize: 18 },
  };
  const s = sizeMap[size] || sizeMap.medium;
  const radius = btnStyle === 'pill' ? '999px' : '8px';
  const isFilled = btnStyle === 'filled';

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: s.gap,
      padding: s.padding, borderRadius: radius, cursor: 'pointer',
      fontSize: s.fontSize, fontWeight: '600', lineHeight: 1, userSelect: 'none',
      border: `1.5px solid ${provider.color}`,
      color: isFilled ? 'white' : provider.color,
      background: isFilled ? provider.color : 'white',
      transition: 'all 0.15s ease',
      boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
      whiteSpace: 'nowrap',
    }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: 'white', borderRadius: '3px',
        width: s.iconSize + 4, height: s.iconSize + 4, flexShrink: 0,
      }}>
        <img
          src={provider.favicon}
          alt={provider.label}
          width={s.iconSize}
          height={s.iconSize}
          style={{ borderRadius: '2px', display: 'block' }}
          onError={e => { e.target.style.display = 'none'; }}
        />
      </span>
      {provider.label}
    </div>
  );
};

// Clean inline block that appears inside article content — mirrors the fingerprint.com style
export const AiSummaryInlineBlock = ({ heading, providers, btnStyle, btnSize, flexAlign }) => (
  <div style={{
    padding: '14px 0',
    margin: '4px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: flexAlign === 'center' ? 'center' : flexAlign === 'flex-end' ? 'flex-end' : 'flex-start',
  }}>
    {/* Heading on its own line */}
    <span style={{ fontSize: '13px', color: '#6B7280', fontWeight: '500' }}>
      {heading || 'Summarize this article with'}
    </span>
    {/* Buttons on the next line */}
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: flexAlign }}>
      {providers.length > 0
        ? providers.map(p => (
            <AiProviderButton key={p.value} provider={p} style={btnStyle} size={btnSize} />
          ))
        : <span style={{ fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic' }}>No providers selected</span>
      }
    </div>
  </div>
);

export const ColorRow = ({ label, colorKey, textKey, settings, onChange, textLabel = "TEXT" }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    <span style={{ fontSize: '12px', fontWeight: '700', color: '#6B7280' }}>{label}</span>
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '6px', border: '1px solid #ddd', borderRadius: '6px', padding: '4px 8px', background: '#fcfcfc' }}>
        <span style={{ fontSize: '11px', color: '#999', width: '25px' }}>BG</span>
        <input
          type="color"
          value={settings[colorKey]}
          onChange={e => onChange(colorKey, e.target.value)}
          style={{ width: '24px', height: '24px', padding: 0, border: 'none', background: 'none', cursor: 'pointer' }}
        />
        <input
          type="text"
          value={settings[colorKey]}
          onChange={e => onChange(colorKey, e.target.value)}
          style={{ width: '60px', border: 'none', background: 'none', fontSize: '12px', outline: 'none' }}
        />
      </div>
      <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '6px', border: '1px solid #ddd', borderRadius: '6px', padding: '4px 8px', background: '#fcfcfc' }}>
        <span style={{ fontSize: '11px', color: '#999', width: '30px' }}>{textLabel}</span>
        <input
          type="color"
          value={settings[textKey]}
          onChange={e => onChange(textKey, e.target.value)}
          style={{ width: '24px', height: '24px', padding: 0, border: 'none', background: 'none', cursor: 'pointer' }}
        />
        <input
          type="text"
          value={settings[textKey]}
          onChange={e => onChange(textKey, e.target.value)}
          style={{ width: '60px', border: 'none', background: 'none', fontSize: '12px', outline: 'none' }}
        />
      </div>
    </div>
  </div>
);
